<template>
   <div class="flex items-center space-x-2">
      <h2 v-bind="$attrs">{{  headerTitle }}</h2>
   </div>
</template>

<script setup lang="ts">
   defineProps<{
      headerTitle:string,
      extraClass?: string
   }>();
</script>


<style scoped>

</style>